module.exports = __webpack_public_path__ + "static/media/IMG_1455.79c95d4d.JPG";